import { axiosInstance } from "../../utils";

const actions = {
    FETCH_PRODUCTS_REQUESTED: 'FETCH_PRODUCTS_REQUESTED',
    FETCH_PRODUCTS_SUCCEEDED: 'FETCH_PRODUCTS_SUCCEEDED',
    FETCH_PRODUCTS_FAILED: 'FETCH_PRODUCTS_FAILED',

    FETCH_PRODUCT_REQUESTED: 'FETCH_PRODUCT_REQUESTED',
    FETCH_PRODUCT_SUCCEEDED: 'FETCH_PRODUCT_SUCCEEDED',
    FETCH_PRODUCT_FAILED: 'FETCH_PRODUCT_FAILED',

    SEARCH_PRODUCT_REQUESTED: 'SEARCH_PRODUCT_REQUESTED',
    SEARCH_PRODUCT_SUCCEEDED: 'SEARCH_PRODUCT_SUCCEEDED',
    SEARCH_PRODUCT_FAILED: 'SEARCH_PRODUCT_FAILED',

    DELETE_PRODUCT_REQUESTED: 'DELETE_PRODUCT_REQUESTED',
    DELETE_PRODUCT_SUCCEEDED: 'DELETE_PRODUCT_SUCCEEDED',
    DELETE_PRODUCT_FAILED: 'DELETE_PRODUCT_FAILED',

    fetchProducts: (id = undefined) => {
        return {
            type: actions.SEARCH_PRODUCT_REQUESTED,
            payload: id
        }
    },

    fetchProduct: (id = undefined) => {
        return {
            type: actions.FETCH_PRODUCT_REQUESTED,
            payload: id
        }
    },

    removeProduct: (id = undefined) => {
        return {
            type: actions.DELETE_PRODUCT_REQUESTED,
            payload: id
        }
    },

    getProducts: async (params = undefined) => {
        const url = `items`;

        try {
            const products = await axiosInstance.get(url, { params });
            return products.data;
        } catch (error) {
            throw error;
        }
    },

    searchProducts: async (params = {}) => {
        const url = `items`;

        // q param is required
        if (!params.q)
            params.q = ""

        try {
            const products = await axiosInstance.get(url, { params });
            return products.data;
        } catch (error) {
            throw error;
        }
    },

    getProduct: async (productId = undefined) => {
        const url = `items/` + productId;

        try {
            const product = await axiosInstance.get(url);
            return product.data;
        } catch (error) {
            throw error;
        }
    },

    deleteProduct: async (id = undefined) => {
        const url = `items/` + id;

        try {
            const response = await axiosInstance.delete(url);
            return response;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
